module.exports = __webpack_public_path__ + "img/fm.84fb32b9.svg";